// extracted by mini-css-extract-plugin
export var actionButton = "_d9-t";
export var buttonContainer = "_d9-0";
export var buttonContainer2 = "_d9-1";
export var buttonSection = "_d9-2";
export var details = "_d9-3";
export var dropdownItem = "_d9-5";
export var dropdownItemsContainer = "_d9-4";
export var fileInput = "_d9-r";
export var headerButton = "_d9-6";
export var icon = "_d9-7";
export var input = "_d9-8";
export var macroListItem = "_d9-9";
export var mainContent = "_d9-a";
export var microText = "_d9-b";
export var modal = "_d9-w";
export var optionsButton = "_d9-c";
export var paperclip = "_d9-s";
export var pillContent = "_d9-d";
export var preview = "_d9-e";
export var preview2 = "_d9-f";
export var quillEditor = "_d9-q";
export var selectedMacro = "_d9-g";
export var sidebar = "_d9-h";
export var sidebarHeader = "_d9-j";
export var sidebarList = "_d9-i";
export var sidebarListItem = "_d9-k";
export var sidebarSearch = "_d9-l";
export var snoozeDurationWrapper = "_d9-v";
export var statusPillContainer = "_d9-m";
export var tagsContainer = "_d9-n";
export var unselectedMacro = "_d9-o";
export var variable = "_d9-u";
export var wrapper = "_d9-p";